import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Button } from '../Button';
import { useParallax } from '../../hooks/useParallax';
export function FinalCTA() {
  const {
    ref,
    y
  } = useParallax(100);
  return <section ref={ref} className="relative py-32 overflow-hidden flex items-center justify-center" data-id="element-50">
      {/* Parallax Background */}
      <motion.div style={{
      y
    }} className="absolute inset-0 z-0 w-full h-[120%] -top-[10%]" data-id="element-51">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80")'
      }} data-id="element-52" />
      </motion.div>

      {/* Dark Overlay for legibility */}
      <div className="absolute inset-0 z-[1] bg-black/70" data-id="element-53" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-55">
          <Sparkles className="w-10 h-10 text-brand-gold mb-6" data-id="element-56" />

          <h2 className="font-serif text-3xl md:text-5xl text-white mb-6 leading-tight" data-id="element-57">
            Ready for a Heavenly Clean?
          </h2>

          <p className="text-xl text-white/90 font-light mb-12" data-id="element-58">
            Book today and see what spotless really feels like.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-59">
            <Button className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-white rounded-full px-8 min-h-[52px] text-lg shadow-soft" data-id="element-60">
              Book a Free Estimate
            </Button>
            <Button variant="outline" className="w-full sm:w-auto border-white text-white hover:bg-white/10 rounded-full px-8 min-h-[52px] text-lg bg-transparent" data-id="element-61">
              Call Us Now
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}